import Vue from "vue";

const durationFilter = seconds => {
  return new Date(seconds * 1000).toISOString().substring(14, 19);
};

Vue.filter("durationFilter", durationFilter);
export default durationFilter;
